export default __webpack_public_path__ + "static/media/assembly.6560866c.jpg";